import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import ExprInput from "../../../lib/builtin/designerComponents/ExprInput";
let ReportDimsItem = class ReportDimsItem extends Vue {
  constructor() {
    super(...arguments);
    this.dimItem = [{
      key: 'id',
      label: '维度ID',
      width: '80px',
      show: false
    }, {
      key: 'name',
      label: '维度名',
      width: '80px',
      show: false
    }, {
      key: 'public',
      label: '公共维度',
      paddingLeft: '14px',
      tips: '页面公共维度，页面曝光及页面内部元素点击时，会自动上报该维度'
    }, {
      key: 'dimension',
      label: '映射到',
      defaultDisabled: true,
      width: '80px',
      show: () => !this.dimensionDisabled,
      tips: '系统自动分配，业务自定义维度对应系统默认维度（不明含义请勿修改！）'
    }];
  }
  renderDimension() {
    const h = this.$createElement;
    return h("a-select", {
      "style": "width: 80px;",
      "model": {
        value: this.value.dimension,
        callback: $$v => {
          this.$set(this.value, "dimension", $$v);
        }
      }
    }, [this.dimensions.map(d => h("a-select-option", {
      "attrs": {
        "value": d
      }
    }, [d]))]);
  }
  renderPublic() {
    const h = this.$createElement;
    return h("input", _mergeJSXProps([{
      "on": {
        "change": $event => {
          const $$a = this.value.public,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            const $$v = null,
              $$i = this._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && this.$set(this.value, "public", $$a.concat([$$v]));
            } else {
              $$i > -1 && this.$set(this.value, "public", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            this.$set(this.value, "public", $$c);
          }
        }
      },
      "attrs": {
        "type": "checkbox"
      },
      "class": "uc-checkbox",
      "domProps": {
        "checked": Array.isArray(this.value.public) ? this._i(this.value.public, null) > -1 : this.value.public
      }
    }, {
      directives: [{
        name: "model",
        value: this.value.public,
        modifiers: {}
      }]
    }]));
  }
  render() {
    const h = arguments[0];
    const renderMap = {
      defaults: (item, param) => h("input", _mergeJSXProps2([{
        "on": {
          "input": $event => {
            if ($event.target.composing) return;
            this.$set(param, item.key, $event.target.value);
          }
        },
        "class": "uc-inputbox uc-reportDims-item-inputbox",
        "style": `width: ${item.width || '80px'}`,
        "domProps": {
          "value": param[item.key]
        }
      }, {
        directives: [{
          name: "model",
          value: param[item.key],
          modifiers: {}
        }]
      }])),
      public: this.renderPublic,
      dimension: this.renderDimension
    };
    const renderItem = param => {
      var _this$validateStatus, _this$validateStatus2;
      return h("div", {
        "class": "uc-reportDims-item",
        "directives": [{
          name: "show",
          value: typeof param.show === 'function' ? param.show() : true
        }],
        "style": `${param.paddingLeft ? `padding-left: ${param.paddingLeft}` : ''}`
      }, [h("div", {
        "class": "uc-reportDims-item-label"
      }, [param.label, !!param.tips && h("a-tooltip", [h("template", {
        "slot": "title"
      }, [param.tips]), h("a-icon", {
        "attrs": {
          "type": "question-circle"
        },
        "style": "margin-left: 2px;"
      })])]), h("div", {
        "class": "uc-reportDims-item-input"
      }, [renderMap[param.key] ? renderMap[param.key]() : renderMap.defaults(param, this.value), ((_this$validateStatus = this.validateStatus) === null || _this$validateStatus === void 0 ? void 0 : _this$validateStatus[param.key]) && h("div", {
        "class": "uc-reportDims-item-error"
      }, [(_this$validateStatus2 = this.validateStatus) === null || _this$validateStatus2 === void 0 ? void 0 : _this$validateStatus2[param.key]])])]);
    };
    return h("div", {
      "class": "uc-reportDims-list-item"
    }, [this.dimItem.map(renderItem), h("button", {
      "class": "uc-button",
      "on": {
        "click": () => {
          this.$emit('delete');
        }
      }
    }, ["\u5220\u9664"]), h("div", {
      "class": "uc-reportDims-item",
      "style": "width: 100%;",
      "directives": [{
        name: "show",
        value: this.value.public
      }]
    }, [h("div", {
      "class": "uc-reportDims-expr-label"
    }, ["\u516C\u5171\u7EF4\u5EA6\u7684\u503C"]), h("div", {
      "class": "uc-reportDims-item-input"
    }, [h(ExprInput, {
      "class": "uc-reportDims-expr",
      "attrs": {
        "placeholder": "请定义公共维度的值"
      },
      "model": {
        value: this.value.value,
        callback: $$v => {
          this.$set(this.value, "value", $$v);
        }
      }
    })])])]);
  }
};
ReportDimsItem = __decorate([Component({
  name: 'ReportDimItem',
  components: {
    ExprInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        id: '',
        name: '',
        public: false,
        value: '',
        dimension: ''
      })
    },
    dimensions: {
      type: Array,
      default: () => []
    },
    dimensionDisabled: {
      type: Boolean,
      default: true
    },
    validateStatus: {
      type: Object,
      default: () => ({
        id: ''
      })
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
})], ReportDimsItem);
export default ReportDimsItem;
//# sourceMappingURL=ReportDimItem.js.map
